export default __webpack_public_path__ + "static/bf-8430727ea5f3e2d82d4ab51b66103187.svg";